// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1rPrW","title":"Header_title__WpJhl","left":"Header_left__EaGMb","clinicName":"Header_clinicName__2A7LO"};